import React, { useState, useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import Barchart from './Barchart';

function Connections({setloading7, year}){
  //Top 10 interior and exterior connections Data
  const [connectionsData, setconnectionsData] = useState({datasets: [],});
  const [connectionsOptions, setconnectionsOptions] = useState({});
  const [connectionsData2, setconnectionsData2] = useState(null);


  const [excelDataChart3Interior,setexcelDataChart3Interior] = useState([]);
  const [excelDataChart3Exterior,setexcelDataChart3Exterior] = useState([]);

  useEffect(() => {

    var url = "api/topconnections/" + year;
    fetch(url).then((res) =>
      res.json().then((res) => {
        
        setexcelDataChart3Exterior(res.data.top_connections.exterior)
        setexcelDataChart3Interior(res.data.top_connections.interior)
        const listOfIds = res.data.top_connections.exterior.map((connection, i) => {
          return (res.data.top_connections.interior[i]["Α/Δ Προέλευσης"] + "-" + res.data.top_connections.interior[i]["Αεροδρόμιο"]);
        });

        const listOfValues = res.data.top_connections.exterior.map((connection, i) => {
          return res.data.top_connections.interior[i].count;
        });

        const listOfIds2 = res.data.top_connections.interior.map((connection, i) => {
          return (res.data.top_connections.exterior[i]["Α/Δ Προέλευσης"] + "-" + res.data.top_connections.exterior[i]["Αεροδρόμιο"]);
        });

        const listOfValues2 = res.data.top_connections.interior.map((connection, i) => {
          return res.data.top_connections.exterior[i].count;
        });

        setconnectionsData({
          labels: listOfIds,
          datasets: [{
            label: "",
            axis : "y",
            data:listOfValues,
            backgroundColor: "blue",
            borderColor: "black",
            borderWidth: 0.1,
          }]
        })
    
        setconnectionsOptions({
          indexAxis: 'y',
          maintainAspectRatio: false,
          responsive: true,
          "plugins": {
           "legend": {
             "display": false,
           }
         }
    
        })

        setconnectionsData2({
          labels: listOfIds2,
          datasets: [{
            label: "",
            axis : "y",
            data:listOfValues2,
            backgroundColor: "blue",
            borderColor: "black",
            borderWidth: 0.1,
          }]
        })
        setloading7(false);

      })
    )
    .catch((error) => {
      console.log("Refetching data for connections table!")
    })

    

  }, [year, setloading7]);


    return(

      connectionsData2? 
        <div className='row w-100 chart-container'>
            <div className = "col-lg-6">
              <Barchart chartData={connectionsData} chartOptions = {connectionsOptions} excelData ={excelDataChart3Interior}></Barchart>
            </div>
            <div className='col-lg-6'>
              <Barchart chartData={connectionsData2} chartOptions = {connectionsOptions} excelData ={excelDataChart3Exterior}> </Barchart>    
            </div>
        </div> 
      : <ClipLoader size={100} color={'#123abc'} loading={true}/>   
       
       
    )
}




export default Connections;